import { useEffect, useRef, useState } from "react"
import { Smile } from "lucide-react"

const EMOJI_CATEGORIES = {
  "Frequently Used": ["👍", "❤️", "😊", "🎉", "🔥", "👀", "👋", "✨", "🙌", "👏"],
  Smileys: ["😀", "😃", "😄", "😁", "😅", "😂", "🤣", "😊", "😇", "🙂", "🙃", "😉", "😌", "😍", "🥰", "😘"],
  Gestures: ["👍", "👎", "👌", "✌️", "🤞", "🤝", "🙏", "👏", "🙌", "👐", "🤲", "🤝", "🙏", "✍️", "💪", "🦾"],
  Symbols: ["❤️", "🧡", "💛", "💚", "💙", "💜", "🖤", "💔", "✨", "💫", "⭐️", "🌟", "💥", "💢", "💤", "💦"],
  Nature: ["🌺", "🌸", "💐", "🌷", "🌹", "🌻", "🌼", "🌱", "🌲", "🌳", "🌴", "🍀", "🍁", "🍂", "🍃", "🌾"],
}


const EmojiButton = ({ emoji, onClick }) => (
  <button
    onClick={() => onClick(emoji)}
    className="p-2 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg text-xl transition-colors"
  >
    {emoji}
  </button>
)

export function EmojiPicker({ onSelect, onClose }) {
  const [selectedCategory, setSelectedCategory] = useState("Frequently Used")
  const pickerRef = useRef(null)

  useEffect(() => {
    function handleClickOutside(event) {
      if (pickerRef.current && !pickerRef.current.contains(event.target)) {
        onClose()
      }
    }

    document.addEventListener("mousedown", handleClickOutside)
    return () => document.removeEventListener("mousedown", handleClickOutside)
  }, [onClose])

  const handleEmojiSelect = (emoji) => {
    onSelect(emoji)
    // Don't close the picker when selecting an emoji
    // This allows users to add multiple emojis
  }

  return (
    <div
      className="fixed inset-0 z-50 flex items-end justify-center sm:items-center"
      onClick={(e) => e.stopPropagation()}
    >
      <div className="absolute inset-0 bg-black/20" onClick={onClose} />
      <div
        ref={pickerRef}
        className="relative w-full sm:w-[348px] max-h-[450px] bg-white dark:bg-gray-900 rounded-t-xl sm:rounded-xl shadow-lg border border-gray-200 dark:border-gray-800 overflow-hidden"
      >
        {/* Header */}
        <div className="flex items-center justify-between p-3 border-b border-gray-200 dark:border-gray-800">
          <h3 className="text-sm font-medium">Emoji</h3>
          <button onClick={onClose} className="text-gray-500 hover:text-gray-700 dark:hover:text-gray-300">
            <Smile className="w-5 h-5" />
          </button>
        </div>

        {/* Category Tabs */}
        <div className="flex overflow-x-auto p-2 border-b border-gray-200 dark:border-gray-800 hide-scrollbar">
          {Object.keys(EMOJI_CATEGORIES).map((category) => (
            <button
              key={category}
              onClick={() => setSelectedCategory(category)}
              className={`flex-none px-3 py-1.5 text-sm rounded-lg mr-2 ${
                selectedCategory === category
                  ? "bg-gray-100 dark:bg-gray-800 text-gray-900 dark:text-white"
                  : "text-gray-500 hover:text-gray-900 dark:hover:text-white"
              }`}
            >
              {category}
            </button>
          ))}
        </div>

        {/* Emoji Grid */}
        <div className="p-2 overflow-y-auto max-h-[300px]">
          <div className="grid grid-cols-8 gap-1">
            {EMOJI_CATEGORIES[selectedCategory].map((emoji) => (
              <EmojiButton key={emoji} emoji={emoji} onClick={handleEmojiSelect} />
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}

